import { render } from "./FooterBar.vue?vue&type=template&id=7588283c"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=7588283c&lang=css"
script.render = render

export default script